import './github-markdown-light.css'
import clsx, { ClassValue } from 'clsx'
import ReactMarkdown, { Components } from 'react-markdown'
import remarkGfm from 'remark-gfm'

export type FormattedTextProps = {
  text: string | null
  className?: ClassValue
}

const components: Partial<Components> = {
  p: ({ ...props }) => <p {...props} />,
  h3: ({ ...props }) => <h3 className="text-sm font-bold" {...props} />,
  ul: ({ ...props }) => <ul className="pl-4 list-disc mb-2 list-inside [&_p]:inline" {...props} />,
  ol: ({ ...props }) => <ol className="pl-4 list-decimal mb-2 list-inside [&_p]:inline" {...props} />,
  a: ({ ...props }) => <a className="font-medium link link-hover" target="_blank mb-2" {...props} />,
  pre: ({ ...props }) => <code className="pb-2 overflow-x-auto" {...props} />
}

export function FormattedText (props: FormattedTextProps) {
  const { text, className } = props

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={components}
      className={clsx(className)}
    >
      {text}
    </ReactMarkdown>
  )
}
